/**
 * HFLEX incl./exkl. moms switch. Used on the product page price and in the header.
 * The choice is stored in localStorage and reflected as `prices-ex-vat` on <html>;
 * every switch on the page stays in sync through the `vat-mode:change` event.
 */
if (!customElements.get('vat-toggle')) {
  customElements.define(
    'vat-toggle',
    class VatToggle extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const button = event.target.closest('[data-mode]');
          if (!button) return;
          const mode = button.dataset.mode;
          try {
            localStorage.setItem('vatMode', mode);
          } catch (e) {}
          document.documentElement.classList.toggle('prices-ex-vat', mode === 'excl');
          document.dispatchEvent(new CustomEvent('vat-mode:change', { detail: { mode } }));
        };
        this.onModeChange = () => this.sync();
        this.addEventListener('click', this.onClick);
        document.addEventListener('vat-mode:change', this.onModeChange);
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('vat-mode:change', this.onModeChange);
      }

      sync() {
        const mode = document.documentElement.classList.contains('prices-ex-vat') ? 'excl' : 'incl';
        this.querySelectorAll('[data-mode]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.mode === mode));
        });
      }
    }
  );
}
